import * as React from "react";
import * as main from "../../styles/main.module.scss";
import * as vidsTop from "./style.module.scss";
export const VidReviewsTop = () => {
  return (
    <section className={vidsTop.vidsTop}>
      <div className={main.containerFluid}>
        <div className={vidsTop.vidsTop__container}>
          <div className={vidsTop.vidsTop__content}>
            <div className={vidsTop.vidsTop__uppertext}>С нашей подготовкой вашим детям будет проще учиться, а значит
              они легче и быстрее будут достигать свои цели и раскрывать свой потенциал.
            </div>
            <h2 className={vidsTop.vidsTop__title}>Вы хотите, чтоб ваш ребенок мог:</h2>
            <ul className={vidsTop.vidsTop__block}>
              <li className={vidsTop.vidsTop__item}>
                <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-mog-1.svg" alt=""/>
                <p className={vidsTop.vidsTop__itemText}>пройти год школьной программы за пару месяцев?</p>
              </li>
              <li className={vidsTop.vidsTop__item}>
                <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-mog-2.svg" alt=""/>
                <p className={vidsTop.vidsTop__itemText}>освоить язык на уровне intermediate за полгода?</p>
              </li>
              <li className={vidsTop.vidsTop__item}>
                <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-mog-3.svg" alt=""/>
                <p className={vidsTop.vidsTop__itemText}>читать со скоростью 400-600 слов в минуту, а среднюю книгу с полным пониманием за 3-4 часа?</p>
              </li>
              <li className={vidsTop.vidsTop__item}>
                <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-mog-4.svg" alt=""/>
                <p className={vidsTop.vidsTop__itemText}>запомнить 100 цифр без единой ошибки за 30 минут?</p>
              </li>
              <li className={vidsTop.vidsTop__item}>
                <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-mog-5.svg" alt=""/>
                <p className={vidsTop.vidsTop__itemText}>легко учиться чему угодно?</p>
              </li>
              <li className={vidsTop.vidsTop__item}>
                <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-mog-6.svg" alt=""/>
                <p className={vidsTop.vidsTop__itemText}>имел развитое логическое и критическое мышление?</p>
              </li>
              <li className={vidsTop.vidsTop__item}>
                <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-mog-7.svg" alt=""/>
                <p className={vidsTop.vidsTop__itemText}>был интеллектуально самостоятельной личностью?</p>
              </li>
              <li className={vidsTop.vidsTop__item}>
                <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-mog-8.svg" alt=""/>
                <p className={vidsTop.vidsTop__itemText}>чтобы задачи уровня ЕГЭ даже не рассматривались как серьезные?</p>
              </li>
            </ul>
            <p className={vidsTop.vidsTop__undertext}>Индивидуальные занятия с нашими педагогами помогут вам в
              этом!
            </p>
          </div>
          <div className={vidsTop.vidsTop__row}>
            <div className={vidsTop.vidsTop__col}>

              <div className={vidsTop.vidsTop__videoContainer}>
                <iframe
                  className={vidsTop.videoReview__video}
                  src="https://www.youtube.com/embed/fp7X39n9fqM"
                  title="Анастасия Лещева, отзыв"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className={vidsTop.vidsTop__informationWrapper}>
                <p className={vidsTop.vidsTop__name}>Анастасия Лещева, 15 лет</p>
                <p className={vidsTop.vidsTop__quote}>За полгода выучила испанский и сдала официальный экзамен на уровень носителя, теперь обучаю детей и подростков. Освоила годовую программу 8 класса за 2 недели.</p>
              </div>
            </div>

            <div className={vidsTop.vidsTop__col}>
              <div className={vidsTop.vidsTop__videoContainer}>
                <iframe
                  className={vidsTop.videoReview__video}
                  src="https://www.youtube.com/embed/av9DE7BzYoA"
                  title={"Екатерина Папушкина, видео"}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className={vidsTop.vidsTop__informationWrapper}>
                <p className={vidsTop.vidsTop__name}>Екатерина Папушкина, 14 лет</p>
                <p className={vidsTop.vidsTop__quote}>До Advance ходила в школу через силу, абсолютно не нравилось учиться. После курса за 2,5 месяца выучила французский язык и поступила в школу при французском посольстве.</p>
              </div>
            </div>

            <div className={vidsTop.vidsTop__col}>
              <div className={vidsTop.vidsTop__videoContainer}>
                <iframe
                  className={vidsTop.videoReview__video}
                  title={"Анастасия Силина, видео"}
                  src="https://www.youtube.com/embed/cHaynZQpyEE"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className={vidsTop.vidsTop__informationWrapper}>
                <p className={vidsTop.vidsTop__name}>Анастасия Силина, 15 лет</p>
                <p className={vidsTop.vidsTop__quote}>За два месяца прошла курсы инженера, но&nbsp;поняла, что это не&nbsp;моё. Работаю репетитором, зарабатываю до&nbsp;90&nbsp;000&nbsp;руб./мес.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
